module.exports = __webpack_public_path__ + "static/media/Montserrat-LightItalic.01c4560c.ttf";